import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Column, ColumnType } from 'src/app/models/model'

@Component({
  selector: 'app-dashboard-summary-table',
  templateUrl: './dashboard-summary-table.component.html',
  styleUrls: ['./dashboard-summary-table.component.scss']
})
export class DashboardSummaryTableComponent {
  @Input() columns: Column[] = []
  @Input() data = []
  @Input() routeTo = null
  columnType = ColumnType
  constructor() {}
}
